import { connect } from 'react-redux'
import  Home  from '../components/Home'
import * as carObject from '../reducers/cars'
import * as routes from '../constants/routes'

const mapStateToProps = (state, ownProps) => {
	const totals = carObject.getTotalsArray(state);
	if(!totals.length){
		ownProps.history.push(routes.ADD_CAR)
	}
	return {totals} 
}

export default connect(
  mapStateToProps,
  null
)(Home)


// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js